import Vue from 'vue';
import DetailProduct from './components/DetailProduct';
import SlideCategory from './components/SlideCategory';
import Quota from './components/Quota';
import Search from './components/Search';
import CloseSession from './components/CloseSession';
import InitSession from './components/InitSession';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import MainMenu from './components/MainMenu';


Vue.component('DetailProduct', DetailProduct);
Vue.component('SlideCategory', SlideCategory);
Vue.component('MainMenu', MainMenu);
Vue.component('Quota', Quota);
Vue.component('Search', Search);
Vue.component('CloseSession', CloseSession);
Vue.component('InitSession', InitSession);

new Vue ({
    el: '#app',
    data:  ()=>({

    }),
    methods: {
        getData(){
        }
    },
    beforeMount() {
        this.getData();
    }
})
